<template>
	<div :class="['chat-item-wrap', { active }]" @click.capture="onWrapClick">
		<div v-if="canSwipeDelete()" class="swipe-delete-layer">删除</div>
		<div class="chat-item" :style="itemShiftStyle" @contextmenu.prevent="showRightMenu($event)"
			@touchstart.passive="onPointerDown" @touchmove="onTouchMove" @touchend="onPointerUp"
			@touchcancel="onPointerUp" @mousedown="onMouseDown">
			<img src="@/assets/common/pined.png" alt="pined" class="pined-icon" v-if="pined" />
			<img src="@/assets/common/hint.png" alt="pined" class="hint-icon" v-if="chat.isNotDisturb" />
			<div class="chat-left">
				<head-image :url="chat.headImage" :name="chat.showName" :size="42"
					:id="chat.type == 'PRIVATE' ? chat.targetId : 0" :isShowUserInfo="false"></head-image>
				<div v-show="chat.unreadCount > 0" class="unread-text" :class="chat.isNotDisturb ? 'no-hint' : ''">{{ chat.unreadCount }}</div>
			</div>
			<div class="chat-right">
				<div class="chat-name">
					<div class="chat-name-text">
						<div class="chat-name-text-word" :class="{ 'official-name': officialUserTag == 1 }">{{ chat.showName }}</div>
						<official-tag :user-tag="officialUserTag" :user-tag-img="officialUserTagImg"></official-tag>
						<el-tag v-if="chat.draftContent" size="mini" type="danger" class="tag-draft">草稿</el-tag>
						<el-tag v-if="chat.type == 'GROUP'"  size="mini">群</el-tag>
						<el-tag v-if="chat.type == 'SYSTEM'" size="mini" class="tag-system" >官方</el-tag>
					</div>
					<div class="chat-time-text">{{ showTime }}</div>
				</div>
				<div class="chat-content">
					<div class="chat-at-text">{{ atText }}</div>
					<div v-if="chat.draftContent" class="draft-content">
						<div class="chat-send-name">[草稿]</div>
						<div class="chat-content-text" v-html="draftContentHtml"></div>
					</div>
					<template v-else>
						<div class="chat-send-name" v-show="isShowSendName">{{ chat.sendNickName + ':&nbsp;' }}</div>
						<div class="chat-content-text" :style="history ? 'color: red' : ''" v-html="lastContentHtml"></div>
					</template>
				</div>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import OfficialTag from '../common/OfficialTag.vue';
import RightMenu from '../common/RightMenu.vue';
import { formatMessageHtml, htmlToPlainText } from '@/utils/common';

export default {
	name: "chatItem",
	components: {
		HeadImage,
		OfficialTag,
		RightMenu
	},
	data() {
		return {
			menuItems: [],
			swipeOffset: 0,
			swipeing: false,
			suppressClick: false,
			swipeStartX: null,
			swipeStartY: null,
			touching: false,
		}
	},
	props: {
		chat: {
			type: Object
		},
		active: {
			type: Boolean
		},
		pined: {
			type: Boolean
		},
		history: {
			type: Boolean,
			default: false
		},
		refreshTick: {
			type: Number,
			default: 0
		}
	},
	beforeDestroy() {
		this.unbindMouseSwipe();
	},
	watch: {
		'chat.targetId'() {
			this.resetSwipe();
		},
		'chat.type'() {
			this.resetSwipe();
		}
	},
	methods: {
		canSwipeDelete() {
			return !this.history && this.chat && this.chat.type === 'GROUP';
		},
		getPoint(e) {
			if (e.touches && e.touches[0]) {
				return { x: e.touches[0].clientX, y: e.touches[0].clientY };
			}
			if (e.changedTouches && e.changedTouches[0]) {
				return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
			}
			return { x: e.clientX, y: e.clientY };
		},
		onWrapClick(e) {
			if (this.suppressClick) {
				e.stopPropagation();
				this.suppressClick = false;
			}
		},
		onPointerDown(e) {
			if (!this.canSwipeDelete()) {
				return;
			}
			if (e.touches) {
				this.touching = true;
			}
			const point = this.getPoint(e);
			this.swipeStartX = point.x;
			this.swipeStartY = point.y;
			this.swipeing = false;
			this.swipeOffset = 0;
		},
		onMouseDown(e) {
			if (e.button !== 0 || this.touching) {
				return;
			}
			this.onPointerDown(e);
			if (this.swipeStartX == null) {
				return;
			}
			document.addEventListener('mousemove', this.onMouseMove);
			document.addEventListener('mouseup', this.onMouseUp);
		},
		onMouseMove(e) {
			this.updateSwipe(e, true);
		},
		onMouseUp() {
			this.unbindMouseSwipe();
			this.onPointerUp();
		},
		unbindMouseSwipe() {
			document.removeEventListener('mousemove', this.onMouseMove);
			document.removeEventListener('mouseup', this.onMouseUp);
		},
		onTouchMove(e) {
			this.updateSwipe(e, true);
		},
		updateSwipe(e, preventWhenHorizontal) {
			if (this.swipeStartX == null) {
				return;
			}
			const point = this.getPoint(e);
			const dx = point.x - this.swipeStartX;
			const dy = point.y - this.swipeStartY;
			if (!this.swipeing) {
				if (Math.abs(dx) < 8 && Math.abs(dy) < 8) {
					return;
				}
				if (Math.abs(dy) >= Math.abs(dx)) {
					this.swipeStartX = null;
					return;
				}
				this.swipeing = true;
			}
			if (preventWhenHorizontal && e.cancelable) {
				e.preventDefault();
			}
			this.swipeOffset = Math.max(0, Math.min(dx, 120));
		},
		onPointerUp() {
			if (this.swipeing) {
				this.suppressClick = true;
				if (this.swipeOffset >= 72) {
					this.$emit('delete', this.chat);
				}
			}
			this.resetSwipe();
			if (this.touching) {
				setTimeout(() => {
					this.touching = false;
				}, 400);
			}
		},
		resetSwipe() {
			this.swipeStartX = null;
			this.swipeStartY = null;
			this.swipeing = false;
			this.swipeOffset = 0;
		},
		showRightMenu(e) {
			if (this.history) {
				return;
			}
			const menuItems = [{
				key: 'TOP',
				name: '置顶',
				icon: 'el-icon-top'
			}, {
				key: 'DELETE',
				name: '删除',
				icon: 'el-icon-delete'
			}];
			if (this.pined) {
				menuItems[0] = {
					key: 'CANCELTOP',
					name: '取消置顶',
					icon: 'el-icon-top'
				}
			} else {
				menuItems[0] = {
					key: 'TOP',
					name: '置顶',
					icon: 'el-icon-top'
				}
			}
			if (this.chat.type == 'GROUP') {
				const obj = {
					key: 'NOHINT',
					name: '免打扰',
					icon: 'el-icon-warning'
				}
				if (this.chat.isNotDisturb) {
					obj.name = '取消免打扰'
					obj.key = 'CANCELNOHINT'
				}
				menuItems.push(obj)
			}
			this.$refs.rightMenu.open(e, menuItems);
		},
		onSelectMenu(item) {
			this.$emit(item.key.toLowerCase(), this.msgInfo);
		}
	},
	computed: {
		itemShiftStyle() {
			if (!this.swipeOffset) {
				return null;
			}
			return {
				transform: 'translateX(' + this.swipeOffset + 'px)',
				transition: this.swipeing ? 'none' : 'transform 0.16s ease'
			};
		},
		lastContentHtml() {
			const lastType = this.chat.lastMsgType;
			const asTip = lastType == null || lastType == this.$enums.MESSAGE_TYPE.TIP_TEXT;
			if (this.chat.type == 'GROUP' && asTip && this.$msgType.isGroupOpTip({
				type: this.$enums.MESSAGE_TYPE.TIP_TEXT,
				groupId: lastType == this.$enums.MESSAGE_TYPE.TIP_TEXT ? this.chat.targetId : 0,
				content: this.chat.lastContent
			})) {
				return '';
			}
			return formatMessageHtml(this.chat.lastContent || '', '', 'emoji-small');
		},
		draftContentHtml() {
			return formatMessageHtml(htmlToPlainText(this.chat.draftContent || ''), '', 'emoji-small');
		},
		isShowSendName() {
			if (!this.chat.sendNickName || this.chat.type != 'GROUP') {
				return false;
			}
			if (this.chat.lastMsgType != null) {
				return this.$msgType.isNormal(this.chat.lastMsgType);
			}
			const messages = this.chat.messages;
			if (!messages || !messages.length) {
				return false;
			}
			const lastMsg = messages[messages.length - 1];
			return lastMsg && this.$msgType.isNormal(lastMsg.type);
		},
		showTime() {
			// 由父组件统一驱动时间刷新，避免每个会话项单独定时器
			this.refreshTick;
			return this.$date.toTimeText(this.chat.lastSendTime, true)
		},
		atText() {
			if (this.chat.atMe) {
				return "[有人@我]"
			} else if (this.chat.atAll) {
				return "[@全体成员]"
			}
			return "";
		},
		officialUserTag() {
			if (!this.chat || this.chat.type !== 'PRIVATE') {
				return 0;
			}
			if (this.chat.userTag != null) {
				return this.chat.userTag;
			}
			const friend = this.$store.getters.findFriend(this.chat.targetId);
			return friend && friend.userTag != null ? friend.userTag : 0;
		},
		officialUserTagImg() {
			if (!this.chat || this.chat.type !== 'PRIVATE') {
				return '';
			}
			if (this.chat.userTagImg) {
				return this.chat.userTagImg;
			}
			const friend = this.$store.getters.findFriend(this.chat.targetId);
			return friend && friend.userTagImg ? friend.userTagImg : '';
		},
	}
}
</script>

<style lang="scss" scoped>
.chat-item-wrap {
	position: relative;
	overflow: hidden;
}
.swipe-delete-layer {
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	width: 80px;
	background: #f56c6c;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 13px;
	z-index: 0;
}
.active .chat-item {
	background-color: var(--im-background-active-dark)!important;
}
.chat-item {
	height: 50px;
	display: flex;
	position: relative;
	z-index: 1;
	padding: 5px 10px;
	align-items: center;
	background-color: var(--im-background);
	white-space: nowrap;
	cursor: pointer;

	&:hover {
		background-color: var(--im-background-active);
	}

	.pined-icon {
		height: 12px;
		position: absolute;
		top: 0px;
		right: 6px;
	}
	.hint-icon {
		height: 12px;
		position: absolute;
		top: 0px;
		left: 6px;
	}
	.chat-left {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;

		.unread-text {
			position: absolute;
			background-color: #f56c6c;
			right: -4px;
			top: -8px;
			color: white;
			border-radius: 30px;
			padding: 1px 5px;
			font-size: 10px;
			text-align: center;
			white-space: nowrap;
			border: 1px solid #f1e5e5;
		}
		.no-hint {
			background: var(--im-background-active-dark);
			color: #333;
		}
	}


	.chat-right {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding-left: 10px;
		text-align: left;
		overflow: hidden;

		.chat-name {
			display: flex;
			line-height: 20px;
			height: 20px;

			.chat-name-text {
				flex: 1;
				display: flex;
				align-items: center;
				gap: 4px;
				font-size: var(--im-font-size);
				white-space: nowrap;
				overflow: hidden;

				.chat-name-text-word {
					min-width: 0;
					max-width: 130px;
					text-overflow: ellipsis;
					overflow: hidden;
				}
				.el-tag {
					min-width: 22px;
					text-align: center;
					border-radius: 10px;
					border: 0;
					height: 16px;
				}

				.tag-system {
					font-size: 10px;
					background: #f04e4e;
					color: white;
					margin-left: 2px;
				}
				.tag-draft {
					font-size: 10px;
					margin-left: 2px;
				}
			}

			.chat-time-text {
				font-size: var(--im-font-size-smaller);
				text-align: right;
				color: var(--im-text-color-light);
				white-space: nowrap;
				overflow: hidden;
				padding-left: 10px;
			}
		}
		.draft-content {
			display: flex;
			gap: 2px;
			.chat-send-name {
				color: red!important;
			}
			.chat-content-text {
				height: 22px;
				overflow: hidden;
			}
		}
		.chat-content {
			display: flex;
			line-height: 22px;

			.chat-at-text {
				color: #c70b0b;
				font-size: var(--im-font-size-smaller);
			}

			.chat-send-name {
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-light);
			}


			.chat-content-text {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-light);
			}

		}
	}
}
</style>
